import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import AsyncComponent from './components/AsyncComponent'
import AuthRequired from './components/AuthRequired'
import withTracker from './modules/analytics/gaWithTracker'
import OnboardingReroute from './screens/Onboarding/Reroute'

const AsyncHome = withTracker(AsyncComponent(() => import('./screens/SplashView')))
const AsyncStory = withTracker(AsyncComponent(() => import('./screens/StoryView')))
const AsyncPrivacy = withTracker(AsyncComponent(() => import('./screens/PrivacyView')))
const AsyncProjections = withTracker(AsyncComponent(() => import('./screens/Projections')))
const AsyncTestimonial = withTracker(AsyncComponent(() => import('./screens/TestimonialView')))
const AsyncNewPaymentSource = withTracker(AsyncComponent(() => import('./screens/NewPaymentSource')))
const AsyncFAQ = withTracker(AsyncComponent(() => import('./screens/FAQ')))
const AsyncRSRedirect = withTracker(AsyncComponent(() => import('./components/RSRedirect')))
const AsyncHomeDetail = withTracker(AsyncComponent(() => import('./screens/HomeDetail')))
const AsyncHomeSearch = withTracker(AsyncComponent(() => import('./screens/HomeSearch')))

const AuthOnboarding = withTracker(props => <AuthRequired {...props} component={AsyncComponent(() => import('./screens/Onboarding'))} />)
const AuthAccount = withTracker(props => <AuthRequired {...props} component={AsyncComponent(() => import('./screens/Account'))} />)
const AuthVerifyCredit = withTracker(props => <AuthRequired {...props} component={AsyncComponent(() => import('./screens/VerifyCredit'))} />)
const AuthVerifyDocuments = withTracker(props => <AuthRequired {...props} component={AsyncComponent(() => import('./screens/VerifyDocuments'))} />)
const AsyncUserFirebaseActions = withTracker(AsyncComponent(() => import('./screens/UserFirebaseActions')))
const AsyncDownloadApp = withTracker(AsyncComponent(() => import('./screens/DownloadApp')))

export default () =>
  <Switch>
    <Route path='/' exact component={AsyncHome} />
    <Route path='/story' exact component={AsyncStory} />
    <Route path='/privacy' exact component={AsyncPrivacy} />
    <Route path='/terms' exact component={AsyncPrivacy} />
    <Route path='/projections/:homeId' component={AsyncProjections} />
    <Route path='/onboardings/:id' component={OnboardingReroute} />
    <Route path='/onboarding' component={AuthOnboarding} />
    <Route path='/payment_sources/:userId/new' component={AsyncNewPaymentSource} />
    <Route path='/faq' component={AsyncFAQ} />
    <Route path='/testimonial' exact component={AsyncTestimonial} />
    <Route path='/testimonial/:name' exact component={AsyncTestimonial} />

    <Route path='/rs/:source/:propertyId' component={AsyncRSRedirect} />

    {/*
      <Route path={'/homes-for-rent/:cityState/:addressZip/:homeId'}
        component={AsyncHomeDetail} />
      <Route path={'/homes-for-rent/:cityState'}
        component={AsyncHomeSearch} />
      <Route path={'/homes-for-rent'}
        component={AsyncHomeSearch} />
    */}

    <Redirect from='/homes-for-rent/:cityState/:addressZip/:homeId' to='/homes/:cityState/:addressZip/:homeId' />
    <Redirect from='/homes-for-rent/:cityState' to='/homes/:cityState' />
    <Redirect from='/homes-for-rent' to='/homes' />

    <Route path='/account/verify/credit' component={AuthVerifyCredit} />
    <Route path='/account/verify/documents' component={AuthVerifyDocuments} />
    <Route path='/account/:route' component={AuthAccount} />
    <Route path='/account' component={AuthAccount} />

    <Route path={'/homes/:cityState/:addressZip/:homeId'}
      component={AsyncHomeDetail} />
    <Route path={'/homes/:cityState'}
      component={AsyncHomeSearch} />
    <Route path={'/homes'}
      component={AsyncHomeSearch} />
    <Route path={'/actions'}
      component={AsyncUserFirebaseActions} />

    <Route path='/download' component={AsyncDownloadApp} />
    <Redirect to='/' />
  </Switch>
